export default{
  label:'aspect-ratio',
  valueScope:[
    'embed-responsive-21by9',
    'embed-responsive-16by9',
    'embed-responsive-4by3',
    'embed-responsive-1by1',
  ],
}


// WEBPACK FOOTER //
// ./src/shell/schemas/utilities/embed/aspect-ratio.js